export function insertAt(array, index, ...elements) {
    array.splice(index, 0, ...elements);
}

export function toggleArrayValue(array, value) {
    return array.includes(value) ? array.filter((v) => v !== value) : [...array, value];
}

/**
 * @template T
 * @param {T[]} array
 * @param {number} size
 * @returns {T[][]}
 */
export const chunkArray = (array, size) => {
    if (size <= 0) {
        throw new Error('Chunk size must be a positive number');
    }

    return Array.from({ length: Math.ceil(array.length / size) }, (_, i) => array.slice(i * size, i * size + size));
};

export const arraysEqual = (a, b) => {
    if (a === b) {
        return true;
    }
    if (!a && !b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }
    if (a.length !== b.length) {
        return false;
    }
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((val, idx) => val === sortedB[idx]);
};
